// extracted by mini-css-extract-plugin
export default {"sliderContainer":"ImageZoomSlider_sliderContainer__Uhn0Z"};